<template>
	<div class="nav_bg">
		<div class="main_w1200 fix">
			<div class="nav">
				<p class="fl" v-if='this.$root.logolink'><router-link :to="'home'"><img src="../assets/images/gys_logo.png"></router-link><span v-show="$route.fullPath!='/err'"></span></p>
				<p class="fl" v-else><img src="../assets/images/gys_logo.png"><span></span></p>				
				<div class="nav_intro fl" v-if="this.$root.flagrouter&&userinfo!==null">
					<dl class="nav_txt fl" >
            <dt class="nav_txt_dtfirst">{{userinfo.Name}}</dt>
						<dd>KPI综合分：<b>{{userinfo.KPI===''?'0':userinfo.KPI}}</b><span style="font-size:16px;margin-left:35px;font-weight:bold;color: #ffec00;" title="等级说明：优秀（4.61~5.00）合格（4.36~4.6）绩差（4.26~4.35）淘汰（4.25以下）">{{userinfo.level}}</span></dd>
					</dl>			
					<div  class="navR fl">
						<div class="navR_list Contacts fl">
							<h1 class="fl">联系方式：</h1>
							<ul class="fl" >
                <li>{{userinfo.listcontacts[0].tel}}</li>
								<li></li>
							</ul>
						</div>
						<div class="navR_list fl">
							<h1 class="fl">地址：</h1>
							<ul class="fl">
                <li style="width:250px">{{userinfo.Adress}}</li>
							</ul>
						</div>			
					</div>
				</div>
				<p class="nav_name fl" v-if='!this.$root.flagrouter'>{{$route.meta.title}}</p>
			</div>
		
		</div>
	</div>
</template>
<script>
export default{
	name:'gysnav',
	data(){
		return{
			
		}
    },
    props: {
      userinfo: null

    },
	mounted(){
	 
	},
	watch:{
    //'$route'(to, from) {
    //  console.log("from");
    //  console.log(to);
    //  console.log(from);
    //  //刷新参数放到这里里面去触发就可以刷新相同界面了
    //  //this.getStatus(this.$route.path)
    //}
	},
	methods:{
   
	}
}
</script>
<style lang="less" scoped>
  .level_rate1 {
    color: #ffec00;
  }
  .level_rate2 {
    color: #bd8d1d;
  }
  .level_rate3 {
    color: rgba(255,108,108,1);
  }
  .level_rate4 {
    color: rgba(168,183,199,1);
  }
	.nav_bg{ 
		background:#E31D19; height:80px;
		min-width:1200px;
     }
	.nav{
		color:#fff;
		p{ 
			img{ margin:27px 33px 27px 27px;vertical-align:middle;}
			span{border-right:1px solid #fff;opacity:0.2495; height:27px; display:inline-block; vertical-align:middle;}
			&.nav_name{
				font-size:18px; 
				line-height:80px;
				color:#fff;
				padding-left:30px;
			}
		}
		dl{ padding: 18px 0 0 28px;
			text-align: left;
			width: 320px;
			dt{
		 	font-size:16px; 
		 	line-height:21px;
		 	font-weight:bold;
			}
			dd{
				font-size:12px;
				vertical-align:middle;
				line-height:26px;
				padding-top:4px;
				b{ 
					font-size:20px;
					color:#FFEC00;
					font-weight:bold;
					vertical-align:middle;
					display:inline-block;
					margin-top:-3px;
				}
			}
		}			

	}
  .nav_txt {
    width:350px !important;
  }
  .nav_txt_dtfirst {
    height:20.8px;
    overflow:hidden;
  }
  .navR {
    padding: 15px 0px 0 0;
    vertical-align: middle;
    line-height: 20px;
    padding-right: 4px;
    .Contacts{
			width:162px;
			padding:0 !important;
			margin:0 !important
		}
		.navR_list{
			font-size:12px;
			color:#fff;
			padding:0 72px;
			h1{
				font-weight:bold;
				padding-right:10px;
			}
		ul{
			li{
				line-height:20px;
			}
		  }
	    }
	  }
</style>



// WEBPACK FOOTER //
// src/components/GysNav.vue